import { IDataProvider } from "@/store";
import DocumentHistory from "@/types/documents/document/DocumentHistory";

export interface IDocumentHistoryState {
  documentHistory: DocumentHistory | null;
  documentHistories: DocumentHistory[] | null;
  dataProvider: IDataProvider<DocumentHistory>;
}

export const state: IDocumentHistoryState = {
  documentHistory: null,
  documentHistories: null,
  dataProvider: {
    items: [],
    pager: {
      buttonsToShow: 3,
      currentPage: 1,
      endPage: 1,
      startPage: 1,
      totalPages: 1,
    },
  },
};
